(function(){
'use strict';

/* ---------- stars ---------- */
var STAR_D = 'M10 1.6l2.5 5.1 5.6.8-4 4 .9 5.6-5-2.7-5 2.7.9-5.6-4-4 5.6-.8z';
function starRow(cls){
  var h = '';
  for (var s=0;s<5;s++) h += '<svg viewBox="0 0 20 20" aria-hidden="true"><path class="'+cls+'" d="'+STAR_D+'"/></svg>';
  return h;
}
function paintStars(root){
  var els = (root||document).querySelectorAll('[data-stars]');
  for (var i=0;i<els.length;i++){
    if (els[i].getAttribute('data-painted')) continue;
    var v = parseFloat(els[i].getAttribute('data-stars')) || 0;
    var pct = Math.max(0, Math.min(100, v / 5 * 100));
    els[i].innerHTML = '<span class="sbg">' + starRow('off') + '</span>' +
                       '<span class="sfg" style="width:' + pct.toFixed(1) + '%">' + starRow('on') + '</span>';
    els[i].setAttribute('data-painted','1');
  }
}
paintStars();

/* ---------- UGC video ---------- */
(function vid(){
  var wrap = document.getElementById('vid-wrap');
  var v = document.getElementById('ugc-video');
  var btn = document.getElementById('playbtn');
  if (!btn) return;
  btn.addEventListener('click', function(){
    wrap.classList.add('playing');
    v.play().catch(function(){});
  });
})();

/* ---------- review carousel ---------- */
(function carousel(){
  var track = document.getElementById('carou-track');
  if (!track) return;
  var slidesC = track.children;
  var dots = document.getElementById('carou-dots');
  var n = slidesC.length, at = 0;

  for (var i=0;i<n;i++){
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('role','tab');
    b.setAttribute('aria-label','Review ' + (i+1));
    b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
    (function(idx){ b.addEventListener('click', function(){ go(idx); }); })(i);
    dots.appendChild(b);
  }
  function go(i){
    at = (i + n) % n;
    track.style.transform = 'translateX(' + (-at * 100) + '%)';
    var ds = dots.children;
    for (var j=0;j<ds.length;j++) ds[j].setAttribute('aria-current', j === at ? 'true' : 'false');
    for (var k=0;k<n;k++) slidesC[k].setAttribute('aria-hidden', k === at ? 'false' : 'true');
  }
  document.getElementById('carou-prev').addEventListener('click', function(){ go(at-1); });
  document.getElementById('carou-next').addEventListener('click', function(){ go(at+1); });

  /* swipe on touch */
  var x0 = null;
  track.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
  track.addEventListener('touchend', function(e){
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 45) go(at + (dx < 0 ? 1 : -1));
    x0 = null;
  }, {passive:true});
  go(0);
})();

/* ---------- reviews: render + paginate ----------
   reviews.js is loaded by the REVIEWS section, which sits after the product
   section that loads this file. Deferred scripts run in document order, so at
   the point this file executes MAGNETIK_REVIEWS does not exist yet -- the
   function used to bail here, leaving the list empty and never attaching the
   "Show more reviews" handler.

   Run on DOMContentLoaded instead: every deferred script has finished by then,
   so this no longer depends on which order the sections are arranged in. */
function reviewList(){
  var list = document.getElementById('rev-list');
  var btn  = document.getElementById('rv-more');
  var count= document.getElementById('rv-count');
  if (!list || !btn || !count) return;
  if (typeof MAGNETIK_REVIEWS === 'undefined' || !MAGNETIK_REVIEWS.length) return;

  var data = MAGNETIK_REVIEWS;
  var PAGE = 8, shown = 0;

  var VERIFIED = '<span class="vf"><svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">' +
    '<path d="M10 1l2.4 1.6 2.9-.2.9 2.8 2.3 1.8-1.2 2.6 1.2 2.6-2.3 1.8-.9 2.8-2.9-.2L10 19l-2.4-1.6-2.9.2-.9-2.8L1.5 13l1.2-2.6L1.5 7.8l2.3-1.8.9-2.8 2.9.2z"/>' +
    '</svg>Verified buyer</span>';

  function esc(s){
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }
  function card(r){
    var body = r.b.split('|').map(function(p){ return '<p>' + esc(p) + '</p>'; }).join('');
    return '<article class="rv">' +
      '<div class="hd"><div><div class="name">' + esc(r.n) + '</div>' +
      '<div class="meta">' + VERIFIED + '<span>' + esc(r.d) + '</span></div></div>' +
      '<span class="stars" data-stars="' + r.r + '" aria-label="' + r.r + ' out of 5"></span></div>' +
      (r.t ? '<h4>' + esc(r.t) + '</h4>' : '') +
      body +
      '<div class="variant">' + esc(r.v) + '</div>' +
      '</article>';
  }
  function render(){
    var next = Math.min(shown + PAGE, data.length);
    var html = '';
    for (var i=shown;i<next;i++) html += card(data[i]);
    list.insertAdjacentHTML('beforeend', html);
    shown = next;
    paintStars(list);
    count.textContent = 'Showing ' + shown + ' of ' + data.length + ' written reviews · 232 ratings';
    if (shown >= data.length){
      btn.style.display = 'none';
      count.textContent = 'That is all ' + data.length + ' written reviews · 232 ratings';
    }
  }
  btn.addEventListener('click', render);
  render();
}

/* NOT keyed on readyState === 'loading': a deferred script already runs at
   readyState "interactive", so that test would take the else branch and fire
   before reviews.js had loaded -- the exact problem this is here to solve.
   Wait for the event itself, with load as a backstop and a run-once latch. */
var reviewsStarted = false;
function startReviews(){
  if (reviewsStarted) return;
  reviewsStarted = true;
  reviewList();
}
if (document.readyState === 'complete') {
  startReviews();
} else {
  document.addEventListener('DOMContentLoaded', startReviews);
  window.addEventListener('load', startReviews);
}

/* ---------- entrances, arcs, bars, sticky ---------- */
var reduced = function(){ return matchMedia('(prefers-reduced-motion: reduce)').matches; };
var revs = document.querySelectorAll('.rev-in');
if ('IntersectionObserver' in window){
  var o = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      o.unobserve(e.target);
      setTimeout(function(){ e.target.classList.add('done'); }, 1300);
    });
  }, { rootMargin:'0px 0px -10% 0px', threshold:.1 });
  for (var r=0;r<revs.length;r++) o.observe(revs[r]);

  var barsEl = document.getElementById('bars');
  if (barsEl){
    var bo = new IntersectionObserver(function(es){
      if (!es[0].isIntersecting) return;
      barsEl.classList.add('in'); bo.disconnect();
    }, { threshold:.4 });
    bo.observe(barsEl);
  }
} else {
  for (var r2=0;r2<revs.length;r2++) revs[r2].classList.add('in','done');
  var b2 = document.getElementById('bars'); if (b2) b2.classList.add('in');
}

var arcPaths = [];
(function initArcs(){
  var svgs = document.querySelectorAll('.arcs');
  for (var i=0;i<svgs.length;i++){
    var ps = svgs[i].querySelectorAll('path');
    for (var j=0;j<ps.length;j++){
      var len = 1400;
      try { len = ps[j].getTotalLength() || 1400; } catch(e){}
      ps[j].style.setProperty('--len', Math.ceil(len));
      arcPaths.push({ el:ps[j], svg:svgs[i], len:len, stagger:j*0.10, last:-1 });
    }
  }
})();
function drawArcs(){
  if (document.body.classList.contains('pinned')) return;
  var vh = window.innerHeight;
  for (var i=0;i<arcPaths.length;i++){
    var a = arcPaths[i], rect = a.svg.getBoundingClientRect();
    if (rect.bottom < -200 || rect.top > vh + 200) continue;
    var p = Math.min(1, Math.max(0, (vh*0.92 - rect.top) / (vh*0.52)));
    p = Math.min(1, Math.max(0, (p - a.stagger) / (1 - a.stagger)));
    var e = p*p*(3-2*p);
    if (Math.abs(e - a.last) < 0.01) continue;
    a.last = e;
    a.el.style.strokeDashoffset = (a.len * (1 - e)).toFixed(1);
  }
}

var sticky = document.getElementById('sticky');
var pdp = document.getElementById('pdp');
var stickyOn = null;
function stickyState(){
  if (!sticky || !pdp) return;
  var past = pdp.getBoundingClientRect().bottom < 40;
  var atEnd = document.getElementById('buy').getBoundingClientRect().top < window.innerHeight * 0.9;
  var want = past && !atEnd;
  if (want !== stickyOn){ stickyOn = want; sticky.classList.toggle('on', want); }
}
(function ctaBg(){
  var el = document.getElementById('buy-bg');
  if (!el) return;
  if (!('IntersectionObserver' in window)){ el.style.backgroundImage = "url('assets/hero-ending.jpg')"; return; }
  var o2 = new IntersectionObserver(function(es){
    if (!es[0].isIntersecting) return;
    o2.disconnect();
    el.style.backgroundImage = "url('assets/hero-ending.jpg')";
  }, { rootMargin:'320px' });
  o2.observe(el);
})();

var raf = null;
function onScroll(){
  if (raf !== null) return;
  raf = requestAnimationFrame(function(){ raf = null; drawArcs(); stickyState(); });
}
window.addEventListener('scroll', onScroll, { passive:true });
window.addEventListener('resize', onScroll, { passive:true });
document.addEventListener('visibilitychange', function(){
  document.body.classList.toggle('paused', document.hidden);
});

function pinToFinalStates(){
  document.body.classList.add('pinned');
  for (var i=0;i<arcPaths.length;i++){ arcPaths[i].el.style.strokeDashoffset = '0'; arcPaths[i].last = 1; }
  var b = document.getElementById('bars'); if (b) b.classList.add('in');
  for (var r=0;r<revs.length;r++) revs[r].classList.add('in','done');
  if (raf !== null){ cancelAnimationFrame(raf); raf = null; }
}
function unpin(){
  document.body.classList.remove('pinned');
  for (var i=0;i<arcPaths.length;i++){ arcPaths[i].last = -1; arcPaths[i].el.style.strokeDashoffset = ''; }
  drawArcs();
}
var rmq = matchMedia('(prefers-reduced-motion: reduce)');
var onRmq = function(e){ if (e.matches) pinToFinalStates(); else unpin(); };
if (rmq.addEventListener) rmq.addEventListener('change', onRmq);
else if (rmq.addListener) rmq.addListener(onRmq);

drawArcs(); stickyState();
if (reduced()) pinToFinalStates();

})();
